module.exports = __webpack_public_path__ + "static/media/aruba.3363943e.jpg";